const topicsData = [
  { name: '香蕉视频', count: '98.6万', tag: '热门', color: 'primary' },
  { name: '红桃视频', count: '87.3万', tag: '原创', color: 'accent' },
  { name: '91视频', count: '72.1万', tag: '社区', color: 'primary' },
  { name: '蜜桃视频', count: '65.8万', tag: '高清', color: 'secondary' },
  { name: '樱花视频', count: '51.4万', tag: '新锐', color: 'accent' },
  { name: '糖豆视频', count: '38.9万', tag: '特色', color: 'secondary' },
  { name: '樱桃视频', count: '32.5万', tag: '精品', color: 'primary' },
  { name: '高清播放', count: '156万', tag: '技术', color: 'secondary' },
  { name: '免费在线', count: '203万', tag: '福利', color: 'accent' },
  { name: '不缓冲', count: '89.7万', tag: '体验', color: 'primary' },
  { name: '原创内容', count: '67.3万', tag: '独家', color: 'accent' },
];

export default function Topics() {
  return (
    <section id="topics" className="bg-background-50 section-padding">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            大家都在看
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            当前最受关注的影视平台与内容关键词，热度数据实时更新
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicsData.map((topic, idx) => (
            <a
              key={idx}
              href="#ranking"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border transition-all duration-300 cursor-pointer no-underline ${
                topic.color === 'primary'
                  ? 'border-primary-200 bg-primary-50/60 hover:bg-primary-100 hover:border-primary-300'
                  : topic.color === 'accent'
                  ? 'border-accent-200 bg-accent-50/60 hover:bg-accent-100 hover:border-accent-300'
                  : 'border-secondary-200 bg-secondary-50/60 hover:bg-secondary-100 hover:border-secondary-300'
              }`}
            >
              <span className={`text-sm font-medium ${
                topic.color === 'primary' ? 'text-primary-800' :
                topic.color === 'accent' ? 'text-accent-800' :
                'text-secondary-800'
              }`}>
                {topic.name}
              </span>
              <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${
                topic.color === 'primary' ? 'bg-primary-200 text-primary-700' :
                topic.color === 'accent' ? 'bg-accent-200 text-accent-700' :
                'bg-secondary-200 text-secondary-700'
              }`}>
                {topic.tag}
              </span>
              <span className="text-[10px] text-foreground-400">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}